export const colors = {
  primary: '#b11917',
  placeholder: '#F0F2F5',
  error: '#ff4d4f',
  text: '#1f1f1f',
  textSecondary: '#8c8c8c'
}
